module.exports = __webpack_public_path__ + "static/media/spot5.3b4f7896.webp";